import React from "react";

/**
 * Fila vacía para tablas sin resultados. Renderizar dentro del <tbody>:
 *
 *   {lista.length === 0 ? (
 *     <EmptyTableRow colSpan={8} />
 *   ) : (
 *     lista.map(...)
 *   )}
 */
const EmptyTableRow = ({
  colSpan = 1,
  message = "Sin resultados para esta búsqueda",
}) => (
  <tr>
    <td
      colSpan={colSpan}
      style={{
        textAlign: "center",
        padding: "24px 16px",
        color: "#6b6b6b",
        fontStyle: "italic",
      }}
    >
      {message}
    </td>
  </tr>
);

export default EmptyTableRow;
